<template>
  <div>
    <user-detail-title
      first-bread="瑞普乐园"
      second-bread="瑞普乐园添加"
      first-url="/user/land"
      title-name="瑞普乐园添加"
    >
    </user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="年份">
          <el-input v-model="Alist.year" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件描述">
          <el-input v-model="Alist.description" type="textarea" :rows="8"
                    style="width: 500px;"
          ></el-input>

        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "LandAdd",
    components: { UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        Alist: {
          'year':null,
          'photoUrl':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    methods:{

      GetUrlList(file){
        this.Alist.photoUrl=file.data;
      },
      handleAdd(){
        if ( this.Alist.name || this.Alist.photoUrl || this.Alist.description){
          this.$axios.post('/api/fairyland/add',this.Alist).then(res=>{
            if(res.data.success == true){
              this.Alist= {
                'year':null,
                'photoUrl':null,
                'description':null,
              }//表示Add添加的数据,
              this.$message({
                message:'添加成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('请至少选择一项上传')
        }

      }
    },
  }
</script>

<style scoped>

</style>